import * as XLSX from 'xlsx';
import { supabase } from './supabase';
import { selectAll } from './data';
import { addDays, mskToday } from './alerts';

export const CATS = {
  activation: { label: 'Активация', hint: 'Закрою вакансию: найду человека', color: '#1F7A44', bg: '#EAF6EF' },
  training:   { label: 'Стажировка', hint: 'Новичок выйдет на стажировку', color: '#2E75B6', bg: '#E8F1FA' },
  churn:      { label: 'Откол', hint: 'Ожидаю увольнение на действующем маршруте', color: '#B3261E', bg: '#FDECEA' },
};
export const CAT_ORDER = ['activation', 'training', 'churn'];
export const REASONS = ['Пропал с радаров', 'Низкий сервис', 'Низкое качество', 'Не устроил доход', 'Другое'];

const dow = (iso) => new Date(Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10))).getUTCDay();
export const mondayOf = (iso) => addDays(iso, -((dow(iso) + 6) % 7));
export const currentMonday = () => mondayOf(mskToday());
const MON = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
export const weekLabel = (ws) => {
  const e = addDays(ws, 6);
  return `${ws.slice(8, 10)} ${MON[+ws.slice(5, 7) - 1]} – ${e.slice(8, 10)} ${MON[+e.slice(5, 7) - 1]}`;
};

export async function getStaffPlanBySv(svIds, weekStart) {
  const { data, error } = await supabase.from('sv_staff_plan').select('*')
    .in('sv_id', svIds).eq('week_start', weekStart);
  if (error) throw error;
  return data || [];
}

// Один маршрут на неделе — одна категория (повторный выбор перезаписывает).
export async function saveStaffItem({ sv_id, route_id, week_start, category, reason, userId }) {
  const row = {
    sv_id, route_id, week_start, category,
    reason: category === 'churn' ? String(reason || '').trim() : null,
    created_by: userId || null, updated_at: new Date().toISOString(),
  };
  const { data, error } = await supabase.from('sv_staff_plan')
    .upsert(row, { onConflict: 'route_id,week_start' }).select().single();
  if (error) throw error;
  return data;
}

export async function deleteStaffItem(id) {
  const { error } = await supabase.from('sv_staff_plan').delete().eq('id', id);
  if (error) throw error;
}

// Сводка недели для ТМ / РМ / тренера. scope: { tmId } — только эта команда.
export async function loadStaffSummary(weekStart, scope = {}) {
  const [plan, svs, routes, tms] = await Promise.all([
    selectAll('sv_staff_plan', '*', q => q.eq('week_start', weekStart)),
    selectAll('supervisors', 'id, full_name, tm_id, bu'),
    selectAll('routes', 'id, internal_code, bu, city, is_vacancy, merchandisers(full_name)'),
    selectAll('users', 'id, full_name', q => q.eq('role', 'tm')),
  ]);
  const svById = new Map(svs.map(s => [s.id, s]));
  const routeById = new Map(routes.map(r => [r.id, r]));
  const tmById = new Map(tms.map(t => [t.id, t.full_name]));
  const rows = plan.map(p => {
    const sv = svById.get(p.sv_id) || {};
    const r = routeById.get(p.route_id) || {};
    const m = Array.isArray(r.merchandisers) ? r.merchandisers[0] : r.merchandisers;
    return {
      id: p.id, category: p.category, reason: p.reason || '',
      sv_id: p.sv_id, sv: sv.full_name || '—', tm_id: sv.tm_id, tm: tmById.get(sv.tm_id) || 'Без ТМ',
      bu: r.bu || sv.bu || 'Без BU', city: r.city || 'Без города',
      route: r.internal_code || '—', mrc: r.is_vacancy ? 'Вакансия' : (m && m.full_name) || '',
    };
  }).filter(x => !scope.tmId || x.tm_id === scope.tmId);
  return rows;
}

export function exportStaffExcel(rows, weekStart) {
  const head = ['Неделя', 'BU', 'ТМ', 'Город', 'СВ', 'Категория', 'Маршрут', 'Мерчендайзер', 'Причина'];
  const data = [head, ...rows.map(r => [weekLabel(weekStart), r.bu, r.tm, r.city, r.sv, CATS[r.category].label, r.route, r.mrc, r.reason])];
  const ws = XLSX.utils.aoa_to_sheet(data);
  ws['!cols'] = [{ wch: 18 }, { wch: 14 }, { wch: 22 }, { wch: 18 }, { wch: 22 }, { wch: 14 }, { wch: 16 }, { wch: 26 }, { wch: 30 }];
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: data.length - 1, c: head.length - 1 } }) };
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Кадры');
  XLSX.writeFile(wb, `Планирование_кадров_${weekStart}.xlsx`);
}
